var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpRightBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_2036)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_549_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15561 17.0778L1.41406 15.3362L13.3561 3.39417H2.65802V0.90625H17.5856V15.8338H15.0976V5.13572L3.15561 17.0778Z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4155,
    height: 17.4155,
    fill: "white",
    transform: "translate(0.792969 0.289062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_549_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4155,
    height: 17.4155,
    fill: "white",
    transform: "translate(0.792969 0.289062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightBlack);
export default __webpack_public_path__ + "static/media/arrow-up-right-black.5a263811e0949350391119dbeefd18d2.svg";
export { ForwardRef as ReactComponent };